
import { Bot, Users, Calendar, BarChart3, Mail, MessageSquare, Search, UserCheck, Zap } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { featuresData } from "../data/landingPageData";

const iconMap = {
  "Search": Search,
  "UserCheck": UserCheck,
  "Mail": Mail,
  "Users": Users,
  "BarChart3": BarChart3,
  "Zap": Zap,
  "🤖": Bot,
  "👥": Users,
  "📅": Calendar,
  "📊": BarChart3,
  "💬": MessageSquare,
  "✉️": Mail,
};

const brandColorMap = {
  blue: "bg-red-50 text-red-600 border-red-100",
  green: "bg-slate-50 text-slate-700 border-slate-200", 
  purple: "bg-red-100 text-red-700 border-red-200",
  orange: "bg-blue-50 text-blue-600 border-blue-100",
  pink: "bg-emerald-50 text-emerald-600 border-emerald-100",
  indigo: "bg-amber-50 text-amber-600 border-amber-100",
};

export const FeaturesSection = () => {
  return (
    <section className="px-4 bg-gradient-to-br from-slate-50 to-white py-12 md:py-20">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-slate-900">Native AI-Powered Features</h2>
          <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto">
            Every feature is built from the ground up with AI intelligence, not bolted on as an afterthought
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuresData.map((feature, index) => {
            const IconComponent = iconMap[feature.icon as keyof typeof iconMap] || Bot;
            const colorClass = brandColorMap[feature.color as keyof typeof brandColorMap] || "bg-red-50 text-red-600 border-red-100";
            
            return (
              <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white">
                <CardHeader className="pb-4">
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 border ${colorClass}`}>
                    <IconComponent className="h-6 w-6" />
                  </div>
                  <CardTitle className="text-lg md:text-xl text-slate-900">{feature.title}</CardTitle>
                  <CardDescription className="text-sm md:text-base text-slate-600">
                    {feature.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
